import { Flex } from '@chakra-ui/react';

import { PasswordResetCreate } from './PasswordResetCreate';
import { PasswordResetUpdate } from './PasswordResetUpdate';
import { Wrapper } from '@/components/login/Wrapper';

export function PasswordReset() {
  const params = new URLSearchParams(window.location.search);
  const token = params.get('reset_password_token');

  return (
    <Wrapper
      title="Recruitment happens here"
      desc="A recruitment platform. For recruiters. By recruiters."
    >
      <Flex>
        {token ? (
          <PasswordResetUpdate token={token} />
        ) : (
          <PasswordResetCreate />
        )}
      </Flex>
    </Wrapper>
  );
}
